import types from './types';
import applicationTypes from '../application/types';

const initialState = [];

const activity = ( state = initialState, action ) => {
    switch ( action.type ) {
        case applicationTypes.LOGOUT: return initialState;
        case types.GET_ACTIVITY_COMPLETED:
            return action.payload.data.docList;
        default: return state;
    }
};

export default activity;
